<template>
  <v-container class="pa-16">
    <v-data-table
      :headers="headers"
      :items="ressources"
      class="elevation-0"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [20, 30, 40, 50],
        showFirstLastPage: true,
        itemsPerPageText: 'Lignes par page :',
      }"
      show-select
      item-value="id"
      v-model="selected"
      @click:row="handleTableClick"
      no-data-text=""
      no-results-text=""
    >
      <template v-slot:body.prepend v-if="loader">
        <tr v-for="n in 5" :key="'skeleton-' + n">
          <td :colspan="headers.length + 1">
            <v-skeleton-loader type="table-row" class="mx-5 my-2" />
          </td>
        </tr>
      </template>
      <template v-slot:no-data v-if="!loader">
        Aucune ressources
      </template>
      <template v-slot:top>
        <v-toolbar flat extended extension-height="100">
          <v-toolbar-title id="toolbar-title">EQUIPE</v-toolbar-title>
          <text-input
            prepend-inner-icon="mdi-magnify"
            @keyup="handleSearch"
            class="ml-5 mt-5"
            id="search"
            v-model="search"
            placeholder="Nom de l'agent"
          />
          <v-spacer></v-spacer>
          <Button
            action_name="Désactiver"
            class= "mb-2 mr-2"
            color="primary"
            text
            @clicked="openConfirmDialog"
            :disabled="selected.length === 0"
          />
          <v-dialog v-model="dialog" max-width="418px">
            <template v-slot:activator="{ on, attrs }">
              <Button
                v-bind="attrs"
                v-on="on"
                action_name="Ajouter"
                class="mb-2"
                color="primary"
                text
                @clicked="openAddDialog"
              />
            </template>
            <v-card>
              <v-card-title class="justify-space-between">
                <span class="headline">{{ formTitle }}</span>
                <v-btn color="black" dark icon right @click="close">
                  <v-icon color="#B2BBAB">mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-form ref="form" style="width: 100%" v-model="isValid">
                      <v-col class="pa-0 text-center" cols="12" md="12" sm="6">
                        <input
                          ref="file"
                          accept="image/*"
                          name="image"
                          class="d-none"
                          type="file"
                          @change="setImage"
                        />
                        <v-avatar v-if="showUserImage" size="250">
                          <img
                            :src="userImage"
                            alt="user-image"
                            class="pointer"
                            @click="select_image"
                          />
                        </v-avatar>
                        <div v-if="imageSrc">
                          <vue-cropper
                            ref="cropper"
                            :aspectRatio="ratio"
                            :guides="true"
                            :src="imageSrc"
                            class="mr-2 w-50"
                          ></vue-cropper>
                        </div>
                      </v-col>
                      <v-col class="pa-0" cols="12" md="12" sm="6">
                        <text-input
                          id="name"
                          v-model="editedItem.name"
                          :rules="requiredRules"
                          label="Nom et prénom*"
                        />
                      </v-col>
                      <v-col class="pa-0" cols="12" md="12" sm="6">
                        <text-input
                          id="email"
                          ref="emailField"
                          v-model="editedItem.email"
                          :rules="emailRules"
                          label="Email*"
                          type="email"
                          @input="resetEmailError"
                        />
                      </v-col>
                      <v-col class="pa-0" cols="12" md="12" sm="6">
                        <AutoComplete
                          id="department"
                          v-model="editedItem.department"
                          :items="departments"
                          :rules="requiredRules"
                          label="Département*"
                          return-object
                        />
                      </v-col>
                      <v-col class="pa-0" cols="12" md="12" sm="6">
                        <AutoComplete
                          id="function"
                          v-model="editedItem.function"
                          :items="roles"
                          :rules="requiredRules"
                          label="Fonction*"
                          return-object
                        />
                      </v-col>
                      <v-col class="pa-0" cols="12" md="12" sm="6">
                        <AutoComplete
                          id="temps"
                          v-model="editedItem.role"
                          :items="types"
                          :rules="requiredRules"
                          label="Type de compte*"
                          return-object
                        />
                      </v-col>
                      <v-col class="pa-0" cols="12" md="12" sm="6">
                        <AutoComplete
                          id="status"
                          v-model="statusComputed"
                          :items="account_status"
                          item-text="name"
                          item-value="id"
                          label="Statut*"
                          :rules="[v => v != null || 'Ce champ est obligatoire']"
                        />
                      </v-col>
                      <v-col
                        class="pa-0"
                        cols="12"
                        md="12"
                        sm="6"
                      >
                      <AutoComplete
                        id="dossier"
                        v-model="editedItem.dossierIds"
                        :items="activeDossiers"
                        item-text="name"
                        item-value="id"
                        label="Projet"
                        multiple
                        deletable-chips
                        small-chips
                        :menu-props="{ maxWidth: 280 }"
                      />
                      </v-col>
                      <v-col
                        class="pa-0"
                        cols="12"
                        md="12"
                        sm="6"
                      >
                        <label>Date d'embauche*</label>
                        <custom-date-picker v-model="editedItem.hiringDate" />
                      </v-col>
                      <v-col
                        v-if="editedIndex !== -1"
                        class="pa-0"
                        cols="12"
                        md="12"
                        sm="6"
                      >
                        <label>Date de fin de contrat</label>
                        <custom-date-picker v-model="editedItem.endContractDate" />
                      </v-col>
                    </v-form>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions class="btn-actions">
                <Button v-if="!showEditButton" action_name="Continuer" color="#86CC26" @clicked="save(true)"
                  :loading="loadingContinue" />
                <Button v-if="!showEditButton" action_name="Ajouter" color="#11887E" text @clicked="save(false)"
                  :loading="loadingAdd" />
                <Button v-if="showEditButton" action_name="Modifier" color="#11887E" text @clicked="update(false)"
                  :loading="loadingEdit" />
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="filterDialog" max-width="836px">
            <v-card>
              <v-card-title class="justify-space-between">
                <span class="headline">Filtre</span>
                <v-btn color="black" dark icon right @click="filterDialog = false">
                  <v-icon color="#B2BBAB">mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="6" sm="6" class="ma-0 pt-0 pb-0">
                      <AutoComplete id="functionsUser" v-model="filteredItem.functionsUser" :items="functionsUser"
                        label="Fonction" item-text="name" return-object multiple deletable-chips small-chips />
                    </v-col>
                    <v-col cols="12" md="6" sm="6" class="ma-0 pt-0 pb-0">
                      <AutoComplete id="comptesUser" v-model="filteredItem.comptesUser" :items="comptesUser"
                        label="Compte" item-text="name" return-object multiple deletable-chips small-chips />
                    </v-col>
                    <v-col cols="12" md="6" sm="6" class="ma-0 pt-0 pb-0">
                      <AutoComplete id="departmentsUser" v-model="filteredItem.departmentsUser" :items="departmentsUser"
                        label="Département" item-text="name" return-object multiple deletable-chips small-chips />
                    </v-col>
                    <v-col cols="12" md="6" sm="6" class="ma-0 pt-0 pb-0">
                      <AutoComplete id="status" :items=account_status v-model="editedItem.status" label="Statut de l'agent"
                       item-text="name" return-object deletable-chips small-chips />
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <Button action_name="Filtrer" color="#86CC26" @clicked="
                  pageNumber = 1;
                getUsers();
                filterDialog = false;
                " style="width: 220px" class="ml-5 mr-5 mb-5" />
                <span class="mb-5" style="color:#B2BBAB" @click="handleReset">Réinitialiser</span>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <template v-slot:extension>
            <div class="filter-block">
              <div>
                <template v-for="(functionsUser, index) in filteredItem.functionsUser">
                  <v-chip class="ma-1" :key="functionsUser" close
                    @click:close="handleChipDelete(index, 'functionsUser')">Fonction: {{ functionsUser }}</v-chip>
                </template>
                <template v-for="(comptesUser, index) in filteredItem.comptesUser">
                  <v-chip class="ma-1" :key="comptesUser" close
                    @click:close="handleChipDelete(index, 'comptesUser')">Compte: {{ comptesUser }}</v-chip>
                </template>
                <template v-for="(departmentsUser, index) in filteredItem.departmentsUser">
                  <v-chip class="ma-1" :key="departmentsUser" close
                    @click:close="handleChipDelete(index, 'departmentsUser')">Département: {{ departmentsUser }}</v-chip>
                </template>
                <template v-if="editedItem.status">
                  <v-chip class="ma-1" close @click:close="handleExactChipDelete('status')">
                    Statut : {{ editedItem.status.name }}
                  </v-chip>
                </template>
              </div>
              <div>
                <v-chip class="chip-delete">
                  <v-icon @click="filterDialog = true" outlined>mdi-filter</v-icon>
                </v-chip>
              </div>
            </div>
          </template>
        </v-toolbar>
      </template>
      <template v-slot:item.name="{ item }">
        <Avatar :item="item" class="mr-2" />
        <span>{{ item.name }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" small @click="editItem(item)">
          mdi-pencil
        </v-icon>
      </template>
      <template v-slot:item.status="{ item }">
        <v-icon v-if="item.status == 0" class="outlined inactive-status" >mdi-close</v-icon>
        <v-icon v-if="item.status == 1" class="outlined active-status" >mdi-check</v-icon>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogConfirmDesactivate" max-width="500px" persistent>
      <v-card>
        <v-card-title class="headline">
          Êtes-vous sûr de désactiver ce(s) agent(s) ?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="dark darken-1" text @click="dialogConfirmDesactivate = false">Annuler</v-btn>
          <v-btn color="secondary darken-1" text @click="handleDesactivate()">Désactiver</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import {
  Button,
  Avatar,
  TextInput,
  AutoComplete,
  CustomDatePicker,
} from "@/components/base";
import {
  createUser,
  getAllUsers,
  searchUser,
  getFunctionsUser,
  updateUserInfo,
  desactivateUsers,
} from "@/services/users.api";
import departments from "@/assets/data/departments.json";
import functions from "@/assets/data/functions.json";
import { getAllRoles } from "../../../services/roles.api";
import { getActiveDossiers } from "../../../services/dossiers.api";
import { getDepartments } from "../../../services/getDepartments.api";
import { getActiveUsers } from "../../../services/getActiveUsers.api";

export default {
  components: {
    Button,
    Avatar,
    TextInput,
    AutoComplete,
    VueCropper,
    CustomDatePicker,
  },
  data: () => ({
    filterDialog: false,
    loadingAdd: false,
    loadingContinue: false,
    loadingEdit: false,
    search: "",
    showUserImage: true,
    imageSrc: "",
    ratio: 1,
    imageHost: "",
    functions: functions,
    account_status: [
      {
        id: 1,
        name: "Actif",
      },
      {
        id: 0,
        name: "Inactif",
      },
    ],
    types: ["agent", "admin"],
    showEditButton: false,
    expired: false,
    items: [],
    selected: [],
    functionsUser: [],
    comptesUser: [],
    departmentsUser: [],
    filteredItem: { status: { id: 1, name: "Actif" } },
    departments: departments,
    roles: [],
    dialog: false,
    dialogConfirmDesactivate: false,
    user: {
      image: "default.jpg",
    },
    headers: [
      { text: '', value: 'data-table-select' },
      {
        text: "Agent",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Statut de l'agent", value: "status", align: "center" },
      { text: "Email", value: "email" },
      { text: "Fonction", value: "function" },
      { text: "Compte", value: "role" },
      { text: "Département", value: "department" },
      // { text: "Actions", value: "actions", sortable: false }
    ],
    ressources: [],
    editedIndex: -1,
    editedItem: {
      image: "default.jpg",
    },
    defaultItem: {},
    imageName: "",
    activeDossiers: [],
    isValid: true,
    loader:false,
    options: {},
  }),

  computed: {
    statusComputed: {
      get() {
        if (this.editedItem.status && typeof this.editedItem.status.id !== 'undefined') {
          return { ...this.editedItem.status, id: Boolean(this.editedItem.status.id) };
        }
        return this.editedItem.status;
      },
      set(value) {
        if (value && typeof value.id === 'boolean') {
          this.editedItem.status = { ...value, id: value.id ? 1 : 0 };
        } else {
          this.editedItem.status = value;
        }
      }
    },
    formTitle() {
      return this.editedIndex === -1 ? "Créer un compte" : "Modifier compte";
    },
    userImage() {
      return (
        this.imageHost +
        (this.editedItem.image ? this.editedItem.image : "default.jpg")
      );
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    'editedItem.email'(newVal) {
      if (newVal && this.$refs.emailField?.hasError) {
        this.resetEmailError();
        this.$refs.form.validate();
      }
    }
  },

  created() {
    this.imageHost = process.env.VUE_APP_PHOTOS_PATH;
    this.initialize();
  },

  methods: {
    handleSearch() {
      if (this.search !== "") {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          searchUser(this.search).then((response) => {
            this.ressources = response.data;
          });
        }, 1000);
      } else {
        getAllUsers().then((response) => {
          this.ressources = response.data;
        });
      }
    },
    handleDesactivate() {
      const selectedUsers = { ids: this.selected.map(user => user.id) };
      desactivateUsers(selectedUsers).then(() => {
        this.$swal.fire({ title: "Agent(s) désactivé(s) avec succès !" });
        this.dialogConfirmDesactivate = false;
        this.selected = [];
        this.getUsers();
      });
    },
    handleChipDelete(index, key) {
      this.filteredItem[key].splice(index, 1);
      this.getUsers();
    },
    handleExactChipDelete(key) {
      this.editedItem[key] = null
      this.getUsers()
    },
    handleReset() {
      this.filteredItem = {};
      this.getAllUsers();
    },
    openConfirmDialog() {
      this.dialogConfirmDesactivate = true;
    },
    openAddDialog() {
      if (this.$refs.form) {
        this.$refs.form.reset();
      }
      this.dialog = true;
    },
    setImage: function(e) {
      const file = e.target.files[0];
      if (!file.type.includes("image/")) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imageSrc = event.target.result;
          // Rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
        this.imageName = file.name;
        this.showUserImage = false;
      } else {
        alert("Sorry, FileReader API not supported");
      }
    },
    handleTableClick(row) {
      this.editItem(row);
      this.showEditButton = true;
    },
    getUsers() {
      this.ressources = [];
      this.loader=true;
      if (this.editedItem.status) {
        this.filteredItem.status = [this.editedItem.status.id];
      } else {
        this.filteredItem.status = [];
      }
      getAllUsers(this.pageNumber, this.filteredItem).then((response) => {
        this.ressources = response.data;
        for (let i in this.ressources) {
          let affectation = this.ressources[i].affectation;
          if (affectation) {
            let ids = affectation.map((o) => o.user_id);
            this.ressources[i].affectation = affectation.filter(
              ({ user_id }, index) => !ids.includes(user_id, index + 1)
            );
          }
        }
        this.loader=false;
      });
    },
    initialize() {
      this.loader = true;
      Promise.all([
        getAllUsers().then((response) => {
          this.ressources = response.data;
        }),
        getActiveDossiers().then((response) => {
          this.activeDossiers = response.data.dossiers;
        }),
        getFunctionsUser().then((response) => {
          this.functionsUser = response.data.functionsUser;
        }),
        getActiveUsers('all').then((response) => {
          this.comptesUser = response.data.comptesUser;
        }),
        getDepartments('all').then((response) => {
          this.departmentsUser = response.data.departments;
        }),
        this.getAllRoles(),
      ])
      .finally(() => {
        this.loader = false;
      });
    },
    getAllRoles() {
      getAllRoles().then((response) => {
        this.roles = response.data.map((role) => role.name);
      });
    },
    editItem(item) {
      this.editedIndex = this.ressources.indexOf(item);
      this.editedItem = { ...item };
       if (this.editedItem.hiringDate === '0000-00-00' || !this.editedItem.hiringDate) {
       this.editedItem.hiringDate = null;
       }
       if (this.editedItem.endContractDate === '0000-00-00' || !this.editedItem.endContractDate) {
       this.editedItem.endContractDate = null;
       }
      if (this.editedItem.affectation && Array.isArray(this.editedItem.affectation)) {
        this.editedItem.dossierIds = this.editedItem.affectation.map(a => a.dossier_id);
      } else {
        this.editedItem.dossierIds = [];
      }
      this.dialog = true;
    },
    close() {
      this.resetEmailError();
      this.resetValidation();
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
        this.showEditButton = false;
      });
    },
    select_image() {
      this.$refs.file.click();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
      if (this.$refs.emailField) {
        this.$refs.emailField.errorMessages = [];
        this.$refs.emailField.hasError = false;
      }
    },
    resetEmailError() {
      if (this.$refs.emailField) {
        this.$refs.emailField.errorMessages = [];
        this.$refs.emailField.hasError = false;
      }
      this.emailRules = [
        v => !!v || "L'adresse email est obligatoire",
        v => /.+@.+/.test(v) || "L'adresse email est invalide"
      ];
    },
    updateInfo(item) {
      this.loadingEdit = true;
      this.resetEmailError();
      const originalRules = [...this.emailRules];
      updateUserInfo(item).then((response) => {
        this.loadingEdit = false;
        this.$set(
          this.ressources,
          this.editedIndex,
          { ...this.ressources[this.editedIndex], ...response.data }
        );
        this.showUserImage = true;
        this.imageSrc = false;
        this.imageName = "";
        this.editedItem.image = "default.jpg";
        this.close();
        this.$swal.fire({ title: "Compte modifié avec succès" });
      })
      .catch((error) => {
        this.loadingEdit = false;
        if (error.response && error.response.status === 422) {
          const message = error.response.data.message;
          if (message.includes('email')) {
            this.emailRules = [
              ...originalRules,
              () => message || true
            ];
            
            this.$nextTick(() => {
              this.$refs.form.validate();
            });
          }
        }
      });
    },
    update() {
      this.resetValidation();
      if (this.imageName) {
        const _self = this;
        this.croppedImageSrc = this.$refs.cropper
          .getCroppedCanvas()
          .toDataURL();
        this.$refs.cropper.getCroppedCanvas().toBlob(function(blob) {
          let formData = new FormData();
          formData.append("image_name", _self.imageName);
          formData.append("file", blob);
          formData.append("id", _self.editedItem.id);
          formData.append("name", _self.editedItem.name);
          formData.append("email", _self.editedItem.email);
          formData.append("department", _self.editedItem.department);
          formData.append("function", _self.editedItem.function);
          formData.append("status", _self.editedItem.status);
          formData.append("role", _self.editedItem.role);
          formData.append("endContractDate", _self.editedItem.endContractDate);
          formData.append("dossierIds", _self.editedItem.dossierIds);
          _self.updateInfo(formData);
        });
      } else {
        this.updateInfo(this.editedItem);
      }
    },
    AddNewUser(item, dialogStat) {
      if (!this.isValid) {
        this.$refs.form.validate();
        return;
      }
      if (!this.editedItem.hiringDate) {
        this.$swal.fire({
          icon: "error",
          title: "Le champ Date d'embauche est obligatoire",
        });
        return;
      }
      dialogStat ? (this.loadingContinue = true) : (this.loadingAdd = true);
      createUser(item)
        .then((response) => {
          dialogStat ? (this.loadingContinue = true) : (this.loadingAdd = true);
          this.ressources.push(response.data);
          this.close();
          this.$refs.form.reset();
          this.dialog = dialogStat;
          this.showUserImage = true;
          this.imageSrc = false;
          this.imageName = "";
          this.$swal.fire({ title: "Compte ajouté avec succés" });
        })
        .catch(() => {
          this.$swal.fire({
            icon: "error",
            title: "Cette adresse email est déjà utilisée",
          });
        });
    },
    save(dialogStat) {
      if (this.imageName) {
        const _self = this;
        this.croppedImageSrc = this.$refs.cropper
          .getCroppedCanvas()
          .toDataURL();
        this.$refs.cropper.getCroppedCanvas().toBlob(function(blob) {
          let formData = new FormData();
          formData.append("image_name", _self.imageName);
          formData.append("file", blob);
          formData.append("name", _self.editedItem.name);
          formData.append("email", _self.editedItem.email);
          formData.append("department", _self.editedItem.department);
          formData.append("function", _self.editedItem.function);
          formData.append("status", _self.editedItem.status);
          formData.append("role", _self.editedItem.role);
          formData.append("dossierIds", _self.editedItem.dossierIds);
          formData.append("hiringDate", _self.editedItem.hiringDate);
          _self.AddNewUser(formData, dialogStat);
        });
      } else {
        this.AddNewUser(this.editedItem, dialogStat);
      }
    },
  },
};
</script>
<style scoped>
.disabled-field {
  pointer-events: none;
}
</style>
<style>
.v-menu__content .v-list-item__content {
  max-width: 280px;
  white-space: normal !important;
  word-break: break-word;
}
</style>